import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {
  getAllDataFromLocalForage,
} from 'ngrx-store-persist';
import localForage from 'localforage';

// Set up localForage config 
localForage.config({
  driver: localForage.INDEXEDDB,
  name: 'holcim',
});

getAllDataFromLocalForage({
  keys: ['userDetails', 'httpUrl'],
} as any ).then(() => {
  if (environment.production) {
    enableProdMode();
  }
  if (
    !window.location.href.includes('localhost') &&
    !window.location.href.includes('staging')
  ) {
    window.console.log = () => {};
  }
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
});



